import { BrowserRouter, Route, Routes as RouterRoutes } from "react-router";
import PrivateRoute from "../components/PrivateRoute";
import AccesInterditPage from "./AccesInterditPage";
import ConsulterAdbPage from "./Adb/ConsulterAdbPage";
import RechercheAdbPage from "./Adb/RechercheAdbPage";
import ActivationComptePage from "./Compte/ActivationComptePage";
import DashboardPage from "./DashboardPage";
import AjouterBienPage from "./DossierLocation/BienPage";
import CalculLoyerPage from "./DossierLocation/CalculLoyer";
import PiecesJustificativesPage from "./DossierLocation/PiecesJustificativesPage";
import SelectAdbSitePage from "./DossierLocation/SelectAdbSitePage";
import AjouterSituationPersonnellePage from "./DossierLocation/SituationPersonnellePage";
import SituationProfessionnellePage from "./DossierLocation/SituationProfessionnellePage";
import SyntheseDossierLocationPage from "./DossierLocation/SyntheseDossierLocationPage";
import EnSavoirPlusPage from "./EnSavoirPlusPage";
import HomePage from "./HomePage";
import LabelisationPage from "./LabelisationPage";
import LandingPage from "./LandingPage";
import MentionsLegalesPage from "./MentionsLegalesPage";
import MessagesPage from "./MessagesPage";
import PageIntrouvable from "./PageIntrouvable";
import ProtectionDonneesPage from "./ProtectionDonneesPage";
import AjouterUtilisateur from "./Utilisateurs/AjouterUtilisateurAdb/index";
import AjouterUtilisateurBesse from "./Utilisateurs/AjouterUtilisateurBesse";
import IUtilisateurs from "./Utilisateurs/index";
import ModifierUtilisateur from "./Utilisateurs/ModifierUtilisateurAdb";
import ModifierUtilisateurBesse from "./Utilisateurs/ModifierUtilisateurBesse";

function Routes() {
  return (
    <BrowserRouter>
      <RouterRoutes>
        <Route path="/" element={<HomePage />} />
        {/*<Route path="/on-parle-de-nous" element={<OnParleNousPage />} />*/}
        <Route path="/en-savoir-plus" element={<EnSavoirPlusPage />} />
        <Route path="/landing-page" element={<LandingPage />} />
        <Route path="/labelisation" element={<LabelisationPage />} />
        {/* PublicRoute */}
        <Route path="/mentions-legales/" element={<MentionsLegalesPage />} />
        <Route
          path="/protection-des-donnees/"
          element={<ProtectionDonneesPage />}
        />
        <Route
          path="/activer-compte/:token"
          element={<ActivationComptePage />}
        />
        <Route path="/accesInterdit/" element={<AccesInterditPage />} />
        {/* Dashboard connecté */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashboardPage />
            </PrivateRoute>
          }
        />
        {/* Selection site et adb connecté */}
        <Route
          path="/dossier-location/selection-adb"
          element={
            <PrivateRoute>
              <SelectAdbSitePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dossier-location/bien"
          element={
            <PrivateRoute>
              <AjouterBienPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dossier-location/situation-personnelle"
          element={
            <PrivateRoute>
              <AjouterSituationPersonnellePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dossier-location/situation-professionnelle"
          element={
            <PrivateRoute>
              <SituationProfessionnellePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dossier-location/pieces-justificatives"
          element={
            <PrivateRoute>
              <PiecesJustificativesPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dossier-location/synthese"
          element={
            <PrivateRoute>
              <SyntheseDossierLocationPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dossier-location/calcul-loyer"
          element={
            <PrivateRoute>
              <CalculLoyerPage />
            </PrivateRoute>
          }
        />
        {/* Adb */}
        <Route
          path="/mes-administrateurs-de-biens"
          element={
            <PrivateRoute>
              <RechercheAdbPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/mes-administrateurs-de-biens/consulter"
          element={
            <PrivateRoute>
              <ConsulterAdbPage />
            </PrivateRoute>
          }
        />
        {/* Utilisateurs */}
        <Route
          path="/mes-utilisateurs"
          element={
            <PrivateRoute>
              <IUtilisateurs />
            </PrivateRoute>
          }
        />
        {/* Créer Utilisateurs */}
        <Route
          path="/mes-utilisateurs/ajouter"
          element={
            <PrivateRoute>
              <AjouterUtilisateur />
            </PrivateRoute>
          }
        />
        {/* Créer Utilisateurs Besse */}
        <Route
          path="/mes-utilisateurs/ajouterBesse"
          element={
            <PrivateRoute>
              <AjouterUtilisateurBesse />
            </PrivateRoute>
          }
        />
        <Route
          path="/mes-utilisateurs/modifier"
          element={
            <PrivateRoute>
              <ModifierUtilisateur />
            </PrivateRoute>
          }
        />
        <Route
          path="/mes-utilisateurs/modifierBesse"
          element={
            <PrivateRoute>
              <ModifierUtilisateurBesse />
            </PrivateRoute>
          }
        />
        <Route
          path="/messages/consulter"
          element={
            <PrivateRoute>
              <MessagesPage />
            </PrivateRoute>
          }
        />

        {/* Page introuvable */}
        <Route element={<PageIntrouvable />} />
      </RouterRoutes>
    </BrowserRouter>
  );
}

export default Routes;
